import reducer from "./reducer";
export { default as PerformanceAnalyticsHistoric } from "./components/index";
export { default as performanceAnalyticsHistoricReducerName } from "./constants";
export default reducer;
